import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Copy-toast near the cursor — matches lighthouse proto `#copy-toast`.
 */
export function CopyToast({ message = 'Copied', x = 0, y = 0, visible = false }) {
  const [pos, setPos] = useState({ left: x, top: y });

  useEffect(() => {
    if (!visible) return undefined;
    const gap = 12;
    const width = 72;
    const height = 28;
    let left = x + gap;
    let top = y + gap;
    if (typeof window !== 'undefined') {
      if (left + width > window.innerWidth - gap) left = x - width - gap;
      if (top + height > window.innerHeight - gap) top = y - height - gap;
      left = Math.max(gap, Math.min(left, window.innerWidth - width - gap));
      top = Math.max(gap, Math.min(top, window.innerHeight - height - gap));
    }
    setPos({ left, top });
    return undefined;
  }, [visible, x, y]);

  if (!visible) return null;
  return (
    <div
      className="onyx-copy-toast is-visible"
      data-testid="onyx-copy-toast"
      aria-live="polite"
      style={{ left: pos.left, top: pos.top }}
    >
      {message}
    </div>
  );
}

CopyToast.propTypes = {
  message: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
  visible: PropTypes.bool,
};

export async function copyTextToClipboard(text) {
  const value = String(text ?? '');
  if (!value) return false;
  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return true;
  }
  const el = document.createElement('textarea');
  el.value = value;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(el);
  return ok;
}
